<template>
  <div class="container mt-5">
    <form @submit.prevent="handleSubmit">
      <div class="container alinear-izquierda">
        <div class="row">

          <!-- <div class="col-md">
            <label for="tracking" class="form-label fw-bold text-start">Tipo de documento:</label>
            <select id="tipoDocumento" class="form-control" v-model="tipoDocumento" required>
              <option disabled value="">Seleccione un tipo de documento</option>
              <option value="G">Guía de Transporte</option>
              <option value="C">Código Único</option>
            </select>
          </div> -->

          <div class="col-md" v-if="tipoDocumento == 'C'">
            <label for="ruc" class="form-label fw-bold text-start">RUC Cliente:</label>
            <input type="text" id="ruc" class="form-control" v-model="identificacionCliente" required
              placeholder="Ingrese el RUC del cliente" />
          </div>

          <div class="col-md">
            <label for="tracking" class="form-label fw-bold text-start">Tracking:</label>
            <input type="text" id="tracking" class="form-control" v-model="tracking" required
              placeholder="Ingrese número de guía de transporte" />
          </div>
          <div class="col-md mt-4">
            <button type="submit" class="btn "
              style="color: white; background-color: #d0312f;">
              Consultar
            </button>
          </div>
        </div>

        <!-- <h2 className="mt-4" v-if="guiaTransporte.codigo != ''">Código # {{ guiaTransporte.codigo }}</h2>
        <div class="row" v-if="guiaTransporte.codigo != ''">
          <div class="col-md-4">
            <strong>Guía Remisión:</strong>
            <div>{{ guiaTransporte.guia_remision }}</div>
          </div>

          <div class="col-md-4">
            <strong>Cliente:</strong>
            <div>{{ guiaTransporte.cliente }}</div>
          </div>

          <div class="col-md-4">
            <strong>Fecha:</strong>
            <div>{{ formatDateToCustomString(guiaTransporte.fecha) }}</div>
          </div>

          <div class="col-md-4">
            <strong>Provincia:</strong>
            <div>{{ guiaTransporte.provincia }}</div>
          </div>

          <div class="col-md-4">
            <strong>Cantón:</strong>
            <div>{{ guiaTransporte.canton }}</div>
          </div>

          <div class="col-md-4">
            <strong>Dirección:</strong>
            <div>{{ guiaTransporte.direccion }}</div>
          </div>

          <div class="col-md-4">
            <strong>Persona que recibe:</strong>
            <div>{{ guiaTransporte.recibe_persona }}</div>
          </div>

          <div class="col-md-4" v-if="guiaTransporte.fecha_entrega != null">
            <strong>Fecha de recepción:</strong>
            <div>{{ formatDateToCustomString(guiaTransporte.fecha_entrega) }}</div>
          </div>
          <div class="col-md-4">
            <strong>Subestado de entrega:</strong>
            <div>{{ guiaTransporte.subestado }}</div>
          </div>
          <div class="col-md-4" v-if="guiaTransporte.estado != null">
            <strong>Estado:</strong>
            <div>
              {{
                (() => {
                  switch (guiaTransporte.estado) {
                    case "PEN":
                      return "Pendiente";
                    case "ENT":
                      return "Entregado";
                    case "RES":
                      return "Reservado";
                    case "RUT":
                      return "En ruta";
                    default:
                      return "Desconocido";
                  }
                })()
              }}
            </div>
          </div>

          <div class="col-md-12">
            <strong>Observación de recepción:</strong>
            <div>{{ guiaTransporte.recibe_observacion }}</div>
          </div>
        </div> -->


        <div class="card mt-4" v-if="guiaTransporte.codigo != ''">
          <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
            <div>
              <i class="bi bi-box-seam me-2"></i>
              <strong>Tracking #{{ guiaTransporte.codigo }}</strong>
            </div>
            <span class="badge" :class="estadoBadgeClass(guiaTransporte.estado)">
              <i class="bi" :class="estadoIconClass(guiaTransporte.estado)"></i>
              {{ estadoTexto(guiaTransporte.estado) }}
            </span>
          </div>

          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-4" v-if="guiaTransporte.guia_remision">
                <i class="bi bi-file-earmark-text me-1"></i><strong>Guía Remisión:</strong>
                <div>{{ guiaTransporte.guia_remision }}</div>
              </div>
              <div class="col-md-4">
                <i class="bi bi-person me-1"></i><strong>Cliente:</strong>
                <div>{{ guiaTransporte.cliente }}</div>
              </div>
              <div class="col-md-4">
                <i class="bi bi-calendar me-1"></i><strong>Fecha:</strong>
                <div>{{ formatDateToCustomString(guiaTransporte.fecha) }}</div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-4">
                <i class="bi bi-geo-alt me-1"></i><strong>Ubicación:</strong>
                <div>
                  <span>
                    {{ guiaTransporte.provincia }}
                  </span>
                  <span v-if="guiaTransporte.canton">
                    - {{ guiaTransporte.canton }}
                  </span>
                  <span v-if="guiaTransporte.parroquia">
                    - {{ guiaTransporte.parroquia }}
                  </span>
                </div>
              </div>
              <!-- <div class="col-md-3">
                <strong>Cantón:</strong>
                <div>{{ guiaTransporte.canton }}</div>
              </div> 
              <div class="col-md-3">
                <strong>Parroquia:</strong>
                <div>{{ guiaTransporte.parroquia }}</div>
              </div>-->
              <div class="col-md-8">
                <i class="bi bi-geo-alt me-1"></i><strong>Dirección:</strong>
                <div>{{ guiaTransporte.direccion }}</div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-4" v-if="guiaTransporte.recibe_persona">
                <i class="bi bi-person-check me-1"></i><strong>Persona que recibe:</strong>
                <div>{{ guiaTransporte.recibe_persona }}</div>
              </div>
              <div class="col-md-4" v-if="guiaTransporte.fecha_entrega">
                <i class="bi bi-calendar-check me-1"></i><strong>Fecha de recepción:</strong>
                <div>{{ formatDateToCustomString(guiaTransporte.fecha_entrega) }}</div>
              </div>
              <div class="col-md-4" v-if="guiaTransporte.subestado">
                <strong>Subestado:</strong>
                <div>{{ guiaTransporte.subestado }}</div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-12">
                <strong>Observación:</strong>
                <div>{{ guiaTransporte.recibe_observacion || 'Sin observaciones.' }}</div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <TrackingTable :trackingData="trackingData" :trackingCode="tracking" :error="error"></TrackingTable>
          </div>
        </div>

        <div class="row mt-4" v-if="guiaTransporte.imagenes.length > 0">
          <h4><i class="bi bi-images me-2"></i>Imágenes del paquete</h4>
          <div class="col-md-4 mb-3" v-for="(imagen, index) in guiaTransporte.imagenes" :key="index">
            <div class="card shadow-sm">
              <img :src="imagen.url" :alt="imagen.nombre" class="card-img-top">
              <div class="card-body text-center">
                <small>{{ imagen.nombre }}</small>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row" v-if="guiaTransporte.imagenes.length > 0">
          <h3>Imágenes</h3>
          <div v-for="(imagen, index) in guiaTransporte.imagenes" :key="index" class="col-md-4">
            <img :src="imagen.url" :alt="imagen.nombre" class="img-fluid"
              style="max-width: 300px; margin-bottom: 10px" />
          </div>
        </div> -->
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { formatDateToCustomString } from "../utils/dateUtils";
import TrackingTable from "./TrackingTable.vue";
export default {
  name: "TrackingForm",
  data() {
    return {
      tracking: "",
      submitted: false,
      tipoDocumento: "",

      identificacionCliente: "",
      trackingData: [],
      error: "",
      guiaTransporte: {
        guia_remision: "",
        codigo: "",
        imagenes: [],
      },
    };
  },
  components: {
    TrackingTable,
  },
  methods: {
    estadoTexto(estado) {
      switch (estado) {
        case "PND": return "Pendiente";
        case "BDG": return "En bodega";
        case "ENT": return "Entregado";
        case "RES": return "Reservado";
        case "RUT": return "En ruta";
        default: return estado;
      }
    },
    estadoIconClass(estado) {
      switch (estado) {
        case "PEN": return "bi-clock";
        case "ENT": return "bi-check-circle";
        case "RES": return "bi-bookmark-check";
        case "RUT": return "bi-truck";
        default: return "bi-question-circle";
      }
    },
    estadoBadgeClass(estado) {
      switch (estado) {
        case "PEN": return "bg-warning text-dark";
        case "ENT": return "bg-success";
        case "RES": return "bg-info text-dark";
        case "RUT": return "bg-primary";
        default: return "bg-secondary";
      }
    },
    formatDateToCustomString,

    handleSubmit() {
      this.submitted = true;

      axios
        .get("https://app.alkeanse.com/api/tracking",
        //.get("http://127.0.0.1:8000/api/tracking",
          {
            params: {
              codigo: this.tracking,
              identificacion: this.tipoDocumento === 'C' ? this.identificacionCliente : null,
            }
          })
        .then((response) => {
          console.log(response);
          this.trackingData = response.data.data.tracking;
          this.guiaTransporte = response.data.data.guia_transporte;
          console.log(response.data);
        })
        .catch((error) => {
          this.trackingData = [];
          this.guiaTransporte = {
            guia_remision: "",
            codigo: "",
            imagenes: [],
          };
          // console.log("joña", error)
          // console.log(error, error.response, error.response.data);
          // if (
          //   error &&
          //   error.response &&
          //   error.response.data &&
          //   error.response.data.data.length > 0
          // )
          console.log(error)
          this.error = error?.response?.data?.data[0] + " ";
          if (this.error != "") {
            this.error += "# " + this.tracking;
          }
          //console.log(error);
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.alinear-izquierda {
  text-align: left !important;
}
</style>